import React, { ChangeEventHandler, FocusEventHandler } from 'react';

interface Props {
    label: string;
    labelClassName?: string;
    labelStyle?: React.CSSProperties;
    id: string;
    inputClassName?: string;
    type: string;
    placeholder: string;
    disabled: boolean;
    maxLength?: number;
    value: string;
    onChange: ChangeEventHandler<HTMLInputElement>;
    onBlur?: FocusEventHandler<HTMLInputElement>;
}

const AppInputText = (props: Props) => {
    const {
        label,
        labelClassName,
        labelStyle,
        inputClassName,
        id,
        type,
        placeholder,
        disabled,
        maxLength,
        value,
        onChange,
        onBlur,
    } = props;

    return (
        <>
            <label
                className={`input-label ${labelClassName}`}
                style={labelStyle}
                htmlFor={type}
            >
                {label}
            </label>
            <input
                className={`login_input ${inputClassName}`}
                type={type}
                name={id}
                id={id}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
            />
        </>
    );
};

export default AppInputText;
